import { createEntityAdapter } from '@reduxjs/toolkit';
import { FeedbackEntity } from 'app/interfaces/entity';
import { FeedbackStoreStatus } from 'modules/feedback/store/enums';
import { FeedbackState } from 'modules/feedback/store/interfaces';

export const entityAdapter = createEntityAdapter<FeedbackEntity>({
  selectId: (data) => data.id,
});

export const initialState: FeedbackState = entityAdapter.getInitialState({
  status: {
    [FeedbackStoreStatus.Creating]: [],
  },
});
